/** Misma validación en la carga y en la API, incluidos los sets cortos por tiempo. */
export function errorMarcador(a: number, b: number): string | null {
  if (!Number.isInteger(a) || !Number.isInteger(b)) return 'El resultado tiene que ser en numeros enteros.';
  if (a < 0 || b < 0) return 'El resultado no puede tener numeros negativos.';
  if (a === b) return 'No hay empates: un set lo gana alguien.';
  const ganador = Math.max(a, b);
  const perdedor = Math.min(a, b);
  if (ganador < 4) return 'El set tiene que llegar por lo menos a 4 games.';
  if (ganador > 9 || (ganador === 9 && perdedor < 7)) return 'Ese resultado no parece un set. Revisa los numeros.';
  return null;
}
